import { useEffect } from "react";
import ErrorPage from "../../components/error-page/ErrorPage";
import Footer from "../../components/footer/Footer";
import AlertMahuti from "../../components/mahuti-alerts/AlertMahuti";
import MahutiHeader from "../../components/mahuti-header/MahutiHeader";
import RouteToDateFlow from "../../components/route-to-date-flow/RouteToDateFlow";
import ShoppingTicketsColumn from "../../components/shopping-tickets-column/ShoppingTicketsColumn";
import { getCoverPhoto } from "../../utils/GlobalParams";
import { discount_message } from "../../utils/routeUtils";

import './LandingPage.css'
import { setAllowUpSale, setCurrentStep, setRefresh } from "../../store/MahutiReducer";
import { useDispatch, useSelector } from "react-redux";
import { checkCartItems } from "../../utils/orderUtils";
import { useLocation, useNavigate } from "react-router-dom";

export default function LandingPage(props) {

    const dispatch = useDispatch();
    const store = useSelector(state => state.reducer);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(setCurrentStep(0))   //kobi test
        dispatch(setRefresh(false))
        dispatch(setAllowUpSale(true))
        checkCartItems(store, dispatch, navigate, location)
    },[])

    useEffect(() => {
        if(props.landingPageParams?.lpName){
            document.cookie = `activity=${props.landingPageParams.lpName}`;
        }
    }, [props.landingPageParams?.lpName])

    return <div id="landingPage" className="landingPage">
        <header className="main-header">
            <MahutiHeader landingPageParams={props.landingPageParams} />
        </header>
        {props.errorMessageHead && <div className="alert alert-text">{props.errorMessageHead}</div>}



        {!props.errorMessageHead ? <>
            <div className="section">
                <div className='cover-img' style={getCoverPhoto(props?.landingPageParams?.Image__c)}>
                    <div className='header-cover-title tickets_main_title almoni_tzar_normal p-0 d-flex align-items-end justify-content-center'>
                        <span>{props.landingPageParams?.Hero_Title__c}</span>
                    </div>
                    <span className="header-cover-subTitle tickets_sub_title d-block mb-lg-2 mb-0">{props.landingPageParams?.Hero_Subtitle__c}</span>
                    <span className="tickets_tiny_title d-block alef">{props.landingPageParams?.Hero_Text__c}</span>
                </div>
                <ShoppingTicketsColumn products={props.productsSF} landingPageParams={props.landingPageParams} isLPLoading={props.isLPLoading} />
            </div>
            <RouteToDateFlow isLPLoading={props.isLPLoading} landingPageParams={props.landingPageParams} />
        </>
            : <ErrorPage errorMessageHead={props.errorMessageHead} />
        }

        {props.landingPageParams?.Show_Marketing_Banner__c && <AlertMahuti landingPageParams={props.landingPageParams} description={discount_message} />}

        <Footer landingPageParams={props.landingPageParams} />
    </div>


}